import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {push} from 'connected-react-router';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import * as actions from '../actions/project';
import TextField from '@material-ui/core/TextField';
import ImageUploader from 'react-images-upload';
import {CardsProjects} from '../components';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    Button: {
      background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7)',
      margin: theme.spacing(2)
    },
    form: {
        '& > *': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    head: {
      'justify-content': 'space-between',
      display: 'inline'

    },
    h1: {
      display: 'inline'
    },
    image: {
      maxWidth: '400px'
    },
    container: {
      'padding-top': theme.spacing(10),
    },
    Card: {
      // minWidth: 300,
      margin: '20px'
    }
}));

function Project({data, getAllProjects, push, createProject}) {
    React.useEffect(() => {
        getAllProjects()
    },[]);
    const updateState = (o) => push(`/project/${o.id}`);
    const [open, setOpen] = React.useState(false);
    const classes = useStyles();


    const [values, setValues] = React.useState({
        title: '',
        file: null,
        fileSourse: null
    });


    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };



    const handleChangeImage = (pictureFiles,pictureDataURLs) => {
      setValues({
        ...values,
        file: pictureFiles[0],
        fileSourse: URL.createObjectURL(pictureFiles[0])
      })
      // console.log(values,'values', URL.createObjectURL(pictureFiles[0]))

    };

    const handleClick = event => {
        createProject(values.title, values.file);
        setOpen(false);
    };


    return (
        <>
      <Container className={classes.container}>
      <div
        className={classes.head}>
          <h1
            className={classes.h1}>
            Projects
          </h1>
          <Button
            className={classes.Button}
            variant="contained"
            color="primary"
            style={{
              background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
            onClick={() => setOpen(true)}
          >
              Add project
          </Button>
      </div>

      <Grid container spacing={6}>
      {Object.values(data).map(
        (obj, key) =>
            <Grid item xs={8} sm={4} key={key}>
              <CardsProjects
                link={`/project/${obj.id}/`}
                title={obj.title}
                text={obj.updated_at.substring(0,10)}
                imgPath={obj.image}
                className={classes.Card}
                >
              </CardsProjects>
            </Grid>
        )
      }
      </Grid>

        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={open}
            onClose={() => setOpen(false)}
        >
            <div className={classes.paper}>
                <h2 id="simple-modal-title">Add project</h2>

                  <form
                    className={classes.form}
                    noValidate autoComplete="off">
                    <TextField
                      id="title"
                      label="Project Name"
                      value={values.title}
                      onChange={handleChange('title')} />
                    </form>
                    <br/>
                    <ImageUploader
                        withIcon={true}
                        buttonText='Choose images'
                        onChange={handleChangeImage}
                        imgExtension={['.jpg', '.gif', '.png', '.gif']}
                        maxFileSize={1048576}
                    />
                  <div>
                    <img
                      className={classes.image}
                      src={values.fileSourse}/>
                  </div>
                  <Button
                    className={classes.Button}
                    variant="contained"
                    color="primary"
                    disabled={values.file === null}
                    style={{
                      background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
                    onClick={() => handleClick()}>
                      Add project
                  </Button>

            </div>
        </Modal>
        </Container>
        </>
    )
}

const mapStateToProps = state => state.project;
const mapDispatchToProps = dispatch => bindActionCreators({
    ...actions,
    push,
}, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(Project)
